// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_95-0";